import { useQuery } from '@apollo/client';

import { BEDROOMS } from '../graphql/query/bedroomsQuery.graphql';

export const useBedroomsQuery = (placeId: string | null) => {
  return useQuery(BEDROOMS, {
    skip: placeId === null,
    variables: { placeId: placeId ?? '' },
  });
};
